export default {
    components: {
        ui: {},
        network: {
            addmember: "components.network.addmember",
        },
        common: {
            schoolSelector: "components.common.schoolSelector",
        },
        shop: {
            inpersonqrarea: "components.shop.inpersonqrarea",
        }
    },
    layouts: {
        account: "layouts.account",
        base: "layouts.base",
        admin: "layouts.admin",
        main: "layouts.main",
        userProfile: "layouts.userProfile",
        portal: "layouts.portal",
        corporate: "layouts.corporate",
        plain: "layouts.plain",
        practice: "layouts.practice",
        dashboard: "layouts.dashboard",
        errors: "layouts.errors",
        navbars: {
            admin: "layouts.navbars.admin",
            auth: "layouts.navbars.auth",
            portal: "layouts.navbars.portal",
            mobile: "layouts.navbars.mobile",
            search: "layouts.navbars.search",
        },
        sidebar: {
            sidebar: "layouts.sidebar.sidebar",
        },
        footers: {
            portalfooter: "layouts.footers.portalfooter",
        },
    },
    screens: {
        account: {
            login: "screens.account.login",
            oldlogin: "screens.account.oldlogin",
            userlogin: "screens.account.userlogin",
            userregister: "screens.account.userregister",
            forgotpassword: "screens.account.forgotpassword",
            changepassword: "screens.account.changepassword",
            register: "screens.account.register",
            ssoredirect: "screens.account.ssoredirect",
        },
        admin: {
            dashboard: "screens.admin.dashboard",
            user: {
                manageemployeeuser: "screens.admin.user.manageemployeeuser",
                manageconsumeruser: "screens.admin.user.manageconsumeruser",
                manageuser: "screens.admin.user.manageuser",
                manageprovideruser: "screens.admin.user.manageprovideruser",
                manageregionuser: "screens.admin.user.manageregionuser",
                managestoreuser: "screens.admin.user.managestoreuser",
            },
            facility: {
                facilityaccess: "screens.admin.facility.facilityaccess",
                facilitycheckin: "screens.admin.facility.facilitycheckin",
                facilityliveview: "screens.admin.facility.facilityliveview",
                facilityaccesshistory: "screens.admin.facility.facilityaccesshistory",
                editfacilityaccess: "screens.admin.facility.editfacilityaccess",
            },
            featureconfiguration: "screens.admin.featureconfiguration",
            setting: "screens.admin.setting",
            products: {
                create: "screens.admin.products.create",
                details: "screens.admin.products.details",
                list: "screens.admin.products.list",
            },
            order: {
                create: "screens.admin.order.create",
                list: "screens.admin.order.list",
                details: "screens.admin.order.details",
            },
            invoices: {
                create: "screens.admin.invoices.create",
                list: "screens.admin.invoices.list",
                details: "screens.admin.invoices.details",
                invoice: "screens.admin.invoices.invoice",
            },
            ecommerce: "screens.admin.ecommerce",
            checkout: "screens.admin.checkout",
            equipment: {
                home: "screens.admin.equipment.home",
                items: "screens.admin.equipment.items",
                categories: "screens.admin.equipment.categories",
                checkouts: "screens.admin.equipment.checkouts",
                reservations: "screens.admin.equipment.reservations",
                managers: "screens.admin.equipment.managers",
                editmanager: "screens.admin.equipment.editmanager",
                viewitem: "screens.admin.equipment.viewitem",
                edititem: "screens.admin.equipment.edititem",
                editcheckout: "screens.admin.equipment.editcheckout",
                editreservation: "screens.admin.equipment.editreservation",
            },
            shop: {
                products: {
                    list: "screens.admin.shop.products.list",
                    edit: "screens.admin.shop.products.edit",
                    detail: "screens.admin.shop.products.detail",
                },
                cart: {
                    cart: "screens.admin.shop.cart.cart",
                },
                orders: {
                    list: "screens.admin.shop.orders.list",
                    detail: "screens.admin.shop.orders.detail",
                },
                checkout: {
                    checkout: "screens.admin.shop.checkout.checkout",
                },
            },
            offerings: "screens.admin.offerings",
        },
        portal: {
            home: "screens.portal.home",
            offerings: "screens.portal.offerings",
            detail: "screens.portal.detail",
            register: "screens.portal.register",
            payment: "screens.portal.payment",
            facilitycalendar: "screens.portal.facilitycalendar",
        },
        plain: {},
        dashboard: {
            account: 'screens.dashboard.account',
            customers: 'screens.dashboard.customers',
            integrations: 'screens.dashboard.integrations',
            settings: 'screens.dashboard.settings',
        },
        errors: {
            notfound: "screens.errors.notfound",
        },
        about: "screens.about",
        default: "screens.default",
        schoolSelection: "screens.schoolSelection",
    },
    session: "session",
    taskqueue: "taskqueue",
};
